(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[847],{

/***/ 7730:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/carbonneutral",
      function () {
        return __webpack_require__(1674);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 1674:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _layouts_default__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6493);
// ** Next imports
// ** File imports


const Pcol = (props)=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
        className: "col-grey1",
        children: props.children
    });
};
const Hcol = (props)=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
        className: "col-black",
        children: props.children
    });
};
const BroadbandInformation = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_layouts_default__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_layouts_default__WEBPACK_IMPORTED_MODULE_1__/* .SEOHead */ .R, {
                title: "Carbon Neutral"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                className: "bg-silver1 pad-top-40 pad-bot-40",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "sec-head",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                            className: "no-margin text-center",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                                children: "Why carbon neutral?"
                            })
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                className: "pad-top-60 pad-bot-60",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "container",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "row",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "col-12",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "div-block-308",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "div-block-310",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "div-block-309",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                                                    className: "heading-151",
                                                    children: "Protecting tropical rainforests in Vanuatu"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "div-block-261",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "text-block-161 white",
                                                        children: "Khole, Espiritu Santo, Vanuatu"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                    className: "paragraph-36",
                                                    children: "Protecting the coastal rainforests of Vanuatu's largest island together with the Serakar Clan of indigenous ni-Vanuatu landowners of the area. The clan consists of five extended families of some 50 individuals descended from Chief Serakar. This projects aims to help protect the forest by supporting these communities financially through carbon offsetting. This protects the native flora and endangered fauna and avifauna. As well as help preserve the land and stunning coast line from erosion during tropical storms."
                                                })
                                            ]
                                        })
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "row",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "col-12",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "faq-textual",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Pcol, {
                                            children: "Scientific models show that human GHG emissions need to fall between 25% and 50% through 2030 in order to limit global warming to levels outlined in the Paris accord—below 2\xba Celsius above pre-industrial levels, or preferably 1.5\xb0C."
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Pcol, {
                                            children: "Even though more than 100 countries have pledged to get to net-zero emissions in 30 years, record heat, biodiversity loss, extreme weather and ice-melting matching scientists’ worst-case scenarios all point out to the fact that world governments are not being successful in fighting against climate change."
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Pcol, {
                                            children: "And this is why businesses need to act, being ideally positioned to be the drivers of positive impact and change. We can’t wait for the world’s governments to act, we must take the initiative one business at a time!"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Hcol, {
                                            children: "What’s carbon offsetting?"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Pcol, {
                                            children: "If one entity, be it a company, country or individual, struggles to limit its GHG (greenhouse gas) emissions, it can purchase credits from a separate party to emit less on its behalf. This allows anyone who can’t make some or all of their operations carbon-free to still take action in working toward the collective effort of reducing greenhouse gas emissions and fighting climate change."
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Pcol, {
                                            children: "These credits must be certified as having actually reduced or avoided greenhouse gas emissions through a science-based analytical model and ongoing verification program. One carbon credit represents one metric ton of CO2(e) that has been reduced, removed or avoided by either decarbonising electricity grids, reducing and avoiding deforestation, improving energy efficiency, reconverting soil, protecting biodiversity and applying frontier technology to sequester CO2 from land, air and sea. Most carbon offsetting projects also bring additional advantages to local communities where they are based – often in developing countries."
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Pcol, {
                                            children: [
                                                "Offsetting plays a key role within global efforts to halve emissions and also gives businesses the opportunity to progress in the fight against climate change immediately.",
                                                " "
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Pcol, {
                                            children: "Since greenhouse gas emissions affect every community, carbon offset projects vary in location and scientific methodology. These projects are designed to cancel out emissions by capturing or destroying them—or even preventing emissions from being released in the first place. Carbon offsets are used to measure that cancellation, and each offset represents the reduction, destruction, or capture of one metric ton of carbon dioxide equivalent emission (CO2e)."
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Hcol, {
                                            children: [
                                                "You can find more about the projects we support here:",
                                                " ",
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                    href: "https://www.nul.to/projects",
                                                    target: "_blank",
                                                    rel: "noopener noreferrer",
                                                    children: "Projects (nul.to)"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
/* harmony default export */ __webpack_exports__["default"] = (BroadbandInformation);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [976,948,910,493,774,888,179], function() { return __webpack_exec__(7730); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);